import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../../../../../../constants/cypressIds';
import { InsuredProfilePageDuskIds } from '../../../../../../../../constants/duskIds';
import {
  activityLogReset,
  selectAddingComment,
  setFilterType
} from '../../../../../../../../redux/modules/activityLog';

import ActivityLogAddComment from './ActivityLogAddComment';
import ActivityLogBody from './ActivityLogBody';
import ActivityLogHeader from './ActivityLogHeader';

const ActivityLog = ({ insuredId, recordId, companyId, jobId }) => {
  const addingComment = useSelector(selectAddingComment);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setFilterType('all_activity', insuredId));

    return () => dispatch(activityLogReset());
  }, [dispatch, insuredId]);

  return (
    <Box
      borderRadius="md"
      data-cy={CypressIds.activityLogSection}
      dusk={InsuredProfilePageDuskIds.activityLogSection}
      layerStyle="bgCard"
    >
      <ActivityLogHeader insuredId={insuredId} recordId={recordId} />
      {addingComment && (
        <ActivityLogAddComment activityId="comment" companyId={companyId} insuredId={insuredId} jobId={jobId} recordId={recordId} />
      )}
      <ActivityLogBody companyId={companyId} insuredId={insuredId} jobId={jobId} recordId={recordId} />
    </Box>
  );
};

ActivityLog.propTypes = {
  insuredId: PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired,
  companyId: PropTypes.number.isRequired,
  jobId: PropTypes.number.isRequired
};

export default ActivityLog;
